import { SensorTypes } from './enums';

export class GqlQueries {
  public static getSensorsPerDeviceTypeQuery(municipalityId: string, sensorType: string, sensorInterfaces: string, readingCurrentValue: string): string {
    return `{
      sensorFilter(
        filter: {
          muninicipality_id: "${municipalityId}"
          or: [
            {deviceType: "${sensorType}"}
          ]
        },
        sort: {
          property: sensor_type, order: ASC
        }
      ) {
        nodes {
          buildingType
          deviceEUI: device_eui
          deviceID: device_id
          sensorID: sensor_id
          sensorType: sensor_type
          alarmRuleEnabled: alarmsRuleEnabled
          ${sensorInterfaces}
          ${readingCurrentValue}
        }
      }
    }`;
  }

  public static getSensorsByMunicipalityQuery(municipalityId: string): string {
    return `{
      sensorFilter(
        filter: {
          and: [
            { muninicipality_id: "${municipalityId}" },
            {
              and: [
                { deviceType: "!${SensorTypes.GAS}" },
                { deviceType: "!${SensorTypes.ELECTRICITY}" },
              ]
            }
          ]
        },
        sort: {
          property: sensor_type
          order: ASC
        }
      )
      {
        nodes {
          device_id
          sensor_id
          sensor_type
          device_eui
          latitude
          longitude
          alarmRuleEnabled: alarmsRuleEnabled
          buildingID
          display_type
          locationContext: location_context
          zip
          buildingType
          street
          district
          name
          b_longitude
          b_latitude
          houseNumber
          currentQuality
          alarmRules { ruleJSON }
          reading(currentValue: true) {
            co2_1
            humidity_1
            temperature_1
            temperature_2
          }
        }
      }
    }`;
  }

  public static getSensorReadingsQuery(sensorId: string, readingFilters: string, sensorProperties: string): string {
    return `
    {
      sensorByID(sensorID:"${sensorId}") {
        reading(${readingFilters}) {
          date
          day
          month
          year
          hour
          ${sensorProperties}
        }
      }
    }`;
  }

  public static getLocationContextByDeviceIdQuery(deviceId: string): string {
    return `
    {
      sensorByID(sensorID: "${deviceId}") {
        locationContext: location_context
      }
    }`;
  }

  public static getSensorDetailsBySensorIdQuery(sensorId: string, sensorInterfaces: string, readingCurrentValue: string): string {
    return `{
      sensorByID(sensorID: "${sensorId}") {
        street
        houseNumber
        zip
        district
        buildingType
        device_eui
        installation_date
        location_context
        sensor_id
        sensor_type
        latitude
        longitude
        b_latitude
        b_longitude
        alarmsRuleEnabled
        ${sensorInterfaces}
        ${readingCurrentValue}
      }
    }`;
  }

  public static getIotProposedReadingsPerDeviceIdQuery(sensorId: string, date: string): string {
    return `
    {
      sensorByID(sensorID: "${sensorId}") {
        deviceId: device_id
        reading(lastofDayView: {date: "${date}"  offset_UTC: "Europe/Berlin"}) {
          date
          el_consumption_obis_180_1
          el_consumption_obis_181_1
          el_consumption_obis_182_1
          el_consumption_obis_280_1
          el_consumption_obis_281_1
          el_consumption_obis_282_1
        }
      }
    }
    `;
  }

  public static getLastHistoricalReadingsQuery(municipalityId: string, date: string): string {
    return `
    {
      sensorFilter(
        filter: {
          and: [
            {muninicipality_id: "${municipalityId}"},
            {or: [{deviceType: "${SensorTypes.ELECTRICITY}"}]}
          ]
        },
        sort: {
          property: sensor_type, order: ASC
        }
      ) {
        nodes {
          deviceId: device_id
          reading(lastAsOfEndOf: {date: "${date}"  offset_UTC: "Europe/Berlin"}) {
            date
            el_consumption_obis_180_1
            el_consumption_obis_181_1
            el_consumption_obis_182_1
            el_consumption_obis_280_1
            el_consumption_obis_281_1
            el_consumption_obis_282_1
          }
        }
      }
    }
    `;
  }

  public static getSpanViewQuery(sensorId: string, startDate: string, endDate: string, granularity: string, measurementType: string): string {
    return `
    {
      sensorByID(sensorID: "${sensorId}") {
        deviceId: device_id
        reading(
          requiredTypes: "${measurementType}"
          spanView: {
          startDate: "${startDate}",
          endDate: "${endDate}",
          offset_UTC: "Europe/Berlin",
          sampleRate: ${granularity}
        }) {
          date
          returned_types
        }
      }
    }`;
  }
}
